
import searchFormMixin from '@/mixins/search-form-mixin';
import staticId from '~/mixins/static-id';
export default {
    mixins: [searchFormMixin, staticId],
    computed: {
        isClient() {
            return process.client;
        }
    }
};
